const ftaRouter = [{
    path: '/fta',
    name: 'fta',
    component: () => import('@/views/Fta/Fta'),
    meta: {
        title: '新华丝路数据库-可视化'
    },
    redirect: {name: 'CountryFtaSummary'},
    children: [
        {
            name: 'CountryFtaSummary',
            path: 'countryFtaSummary',
            component: () => import('@/views/Fta/CountryFtaSummary/CountryFtaSummary'),
            meta: {
                title: '新华丝路数据库-国家自贸区概览',
                permission: 'country_fta_summary',
                menu: 'Overview'
            }
        },
        {
            name: 'FtaInfo',
            path: 'ftaInfo',
            component: () => import('@/views/Fta/FtaInfo/FtaInfo'),
            meta: {
                title: '新华丝路数据库-自贸区信息',
                permission: 'fta_info',
                menu: 'FTZ'
            }
        },
        {
            name: 'FtaAreaInfo',
            path: 'ftaAreaInfo',
            component: () => import('@/views/Fta/FtaAreaInfo/FtaAreaInfo'),
            meta: {
                title: '新华丝路数据库-自贸区片区信息',
                permission: 'fta_area_info',
                menu: 'FTZ Sub-area'
            }
        },
        {
            name: 'TargetContrast',
            path: 'targetContrast',
            component: () => import('@/views/Fta/TargetContrast/TargetContrast'),
            meta: {
                title: '新华丝路数据库-指标对比',
                permission: 'target_contrast',
                menu: 'Indicator Comparison'
            }
        },
        {
            name: 'PolicyQuery',
            path: 'policyQuery',
            component: () => import('@/views/Fta/PolicyQuery/PolicyQuery'),
            meta: {
              title: '新华丝路数据库-政策法规',
              permission: 'policy_query',
              menu: 'Policy & Regulation'
            }
          },
          {
            name: 'InvestmentShow',
            path: 'investmentShow',
            component: () => import('@/views/Fta/InvestmentShow/InvestmentShow'),
            meta: {
              title: '新华丝路数据库-招商合作展示',
              permission: 'investment_show',
              menu: 'Business Cooperation'
            }
          },
          {
            name: 'InvestmentRecommend',
            path: 'investmentRecommend',
            component: () => import('@/views/Fta/InvestmentRecommend/InvestmentRecommend'),
            meta: {
              title: '新华丝路数据库-招商引资推荐',
              permission: 'investment_recommend',
              menu: 'Investment Recommendation'
            }
          },
          {
            name: 'InvestmentRecommendDet',
            path: 'InvestmentRecommendDet/:id',
            component: () => import('@/views/Fta/InvestmentRecommendDet/InvestmentRecommendDet'),
            meta: {
              title: '新华丝路数据库-招商引资推荐详情',
              permission: 'investment_recommend',
              menu: '招商引资推荐详情',
              isShow: true    // 是否隐藏导航
            }
          },
          {
            name: 'noPermission',
            path: 'noPermission',
            component: () => import('@/views/Fta/noPermission/noPermission'),
            meta: {
              title: '没权限',
              // permission: 'investment_recommend',
              menu: '404',
              isShow: true  // 是否隐藏导航
            }
          }
      
    ]
}]

export default ftaRouter
